import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import ButtonRounded from "../buttons/ButtonRounded";
import PopUp from "../popup/PopUp";

export default class PopUpDecor extends PopUp {
    constructor(scene, x, y, { imageKey, description, textPosition, endFunction, textColor = Colors.Text.White, boutonText = "Fermer" }) {
        super(scene, x, y);

        // Ajout du fond
        this.background = this.scene.add.image(0, 0, imageKey).setOrigin(0.5, 0.5);
        this.add(this.background);

        // Ajout du texte
        this.textElmt = this.scene.add.text(textPosition.x, this.background.height / 2 + textPosition.y, description, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: textColor,
            align: 'center',
            // wordWrap: { width: 583 }
        }).setOrigin(0.5, 1);
        this.add(this.textElmt);

        // Ajout bouton fermer
        this.closeButton = new ButtonRounded(this.scene, 0, this.background.height / 2 - 30, { 
            text: boutonText,
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
        });
        this.closeButton.setClickFunction( () => {
            if (endFunction) {
                endFunction();
            }
        } )
        this.add(this.closeButton);
    }

    setClickFunction(func){
        this.closeButton.setClickFunction(func);
    }

    setBackground(textureKey){
        this.background.setTexture(textureKey);
    }

    setText(newText){
        this.textElmt.setText(newText);
    }

    animIn(){
        this.soundManager.playOnce('PaperSlideIn')
        super.animIn();
    }

    animOut(endFunc = null){
        this.soundManager.playOnce('PaperSlideOut')
        super.animOut(endFunc);
    }
}